import { EntryConfigType } from "@/types/entryConfig";

export const ENTRY_TYPES_EXCLUDED_FROM_UI: readonly EntryConfigType[] = ["transcription"];

export const isEntryTypeExcluded = (type?: EntryConfigType | null): boolean => {
  if (!type) return false;
  return ENTRY_TYPES_EXCLUDED_FROM_UI.includes(type);
};

export const filterEntryConfigsForUI = <T extends { type: EntryConfigType }>(entryConfigs: T[]): T[] => {
  return entryConfigs.filter((config) => !isEntryTypeExcluded(config.type));
};

/**
 * Filter entry configs for *selection* surfaces (task-builder pickers).
 *
 * Like {@link filterEntryConfigsForUI} (drops UI-excluded types such as
 * transcription) but additionally hides archived traits so they can't be added
 * to new/edited tasks — EXCEPT any id in `keepIds`, so a trait already selected
 * on the task being edited stays visible/checked even if it has been archived.
 *
 * Do NOT use this on historical/export paths (TaskDetails, CSV export); those
 * must keep rendering archived-but-referenced traits via filterEntryConfigsForUI.
 */
export const filterEntryConfigsForSelection = <
  T extends { id?: string; type: EntryConfigType; isArchived?: boolean }
>(
  entryConfigs: T[],
  { keepIds }: { keepIds?: Iterable<string> } = {}
): T[] => {
  const keep = new Set(keepIds ?? []);
  return filterEntryConfigsForUI(entryConfigs).filter(
    (config) => !config.isArchived || (config.id != null && keep.has(config.id))
  );
};
